export const schema = [
  {
    title: '#',
    colId: 'orderNumber',
    thStyle: {
      textAlign: 'center',
      whiteSpace: 'normal',
    },
    tdStyle: {
      textAlign: 'center',
    },
  },
  {
    title: 'companyAnalysis.peerAnalysis.COMPANY_NAME',
    colId: 'organizationName',
    isI18n: true,
    style: {
      borderRightWidth: 1,
      borderRightStyle: 'solid',
      borderRightColor: '#D9D9D9',
    },
    thStyle: {
      minWidth: '120px',
      textAlign: 'center',
      whiteSpace: 'normal',
    },
    tdStyle: {
      borderRightWidth: 1,
      borderRightStyle: 'solid',
      borderRightColor: '#D9D9D9',
    },
  },
  {
    title: 'companyAnalysis.peerAnalysis.STRUCTURE_TYPE',
    colId: 'structureType',
    isI18n: true,
    style: {
      height: 35,
    },
    thStyle: {
      whiteSpace: 'normal',
      justifyContent: 'center',
    },
    childCol: [
      {
        title: 'companyAnalysis.peerAnalysis.INDIVIDUAL',
        colId: 'individual',
        isI18n: true,
        style: { top: '35px' },
        thStyle: {
          textAlign: 'right',
          whiteSpace: 'normal',
        },
        tdStyle: {
          textAlign: 'right',
        },
      },
      {
        title: 'companyAnalysis.peerAnalysis.STATE_OWNED_ENTERPRISES',
        colId: 'stateOwnedEnterprises',
        isI18n: true,
        style: { top: '35px' },
        thStyle: {
          textAlign: 'right',
          whiteSpace: 'normal',
        },
        tdStyle: {
          textAlign: 'right',
        },
      },
      {
        title: 'companyAnalysis.peerAnalysis.NON_STATE_ENTERPRISES',
        colId: 'nonStateEnterprises',
        isI18n: true,
        style: { top: '35px' },
        thStyle: {
          textAlign: 'right',
          whiteSpace: 'normal',
        },
        tdStyle: {
          textAlign: 'right',
        },
      },
      {
        title: 'companyAnalysis.peerAnalysis.MULTINATIONAL_COMPANIES',
        colId: 'foreignDirectInvestedEnterprises',
        isI18n: true,
        style: { top: '35px' },
        thStyle: {
          textAlign: 'right',
          whiteSpace: 'normal',
        },
        tdStyle: {
          textAlign: 'right',
        },
      },
      {
        title: 'companyAnalysis.peerAnalysis.OTHER',
        colId: 'others',
        isI18n: true,
        style: { top: '35px' },
        thStyle: {
          textAlign: 'right',
          whiteSpace: 'normal',
        },
        tdStyle: {
          textAlign: 'right',
        },
      },
    ],
  },
  {
    title: 'companyAnalysis.peerAnalysis.NUMBER_OF_BRANCHES',
    colId: 'numberOfBranches',
    isI18n: true,
    style: {
      borderLeftWidth: 1,
      borderLeftStyle: 'solid',
      borderLeftColor: '#D9D9D9',
    },
    thStyle: {
      textAlign: 'right',
      whiteSpace: 'normal',
    },
    tdStyle: {
      borderLeftWidth: 1,
      borderLeftStyle: 'solid',
      borderLeftColor: '#D9D9D9',
      textAlign: 'right',
    },
  },
  {
    title: 'companyAnalysis.peerAnalysis.NUMBER_OF_SUBSIDIARIES',
    colId: 'numberOfSubsidiaries',
    isI18n: true,
    thStyle: {
      textAlign: 'right',
      whiteSpace: 'normal',
    },
    tdStyle: {
      textAlign: 'right',
    },
  },
  {
    title: 'companyAnalysis.peerAnalysis.NUMBER_OF_ASSOCIATED_COMPANIES',
    colId: 'numberOfAssociatedCompanies',
    isI18n: true,
    thStyle: {
      textAlign: 'right',
      whiteSpace: 'normal',
    },
    tdStyle: {
      textAlign: 'right',
    },
  },
]
